import React, {useState} from "react";
import styled from "styled-components";
import {MenuItem} from "../../components/Menu";
import {Category} from "../../reducers/project";
import content from "../../content";
import {Mobile, useDesktop} from "../../components/Responsive";
import MenuDrawerMobile from "./MenuDrawerMobile";

const MenuWrapper = styled.div<{ desktop?: boolean }>`
  display: flex;
  flex-direction: ${({ desktop }) => (desktop ? "row" : "column")};
  height: ${({ desktop }) => (desktop ? "42px" : "unset")};
  min-width: 0;
  width: 100%;
  background-color: #f6f5f5;
  font-size: 13px;
`;
function Menu({}: IMenu) {
  const [open, setOpen] = useState(false);
  const desktop = useDesktop();

  return (
    <MenuWrapper onClick={() => setOpen(true)} desktop={desktop}>
      <MenuItem category={[Category.Model, Category.Variant]}>
        {content.getValue("header_model")}
      </MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Color]}>
        {content.getValue("header_color")}
      </MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Size, Category.Side]}>{content.getValue("header_size_and_side")}</MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Glass]}>{content.getValue("header_glass")}</MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Custom, Category.Jamb, Category.JambSize, Category.JambColor]}>
        {content.getValue("header_jambs")}
      </MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Handle, Category.HandleColor, Category.Signboard]}>
        {content.getValue("header_handle")}
      </MenuItem>
      <div style={{border: '1px solid #EAE5E5', height:'25px', margin: 'auto'}}/>
      <MenuItem category={[Category.Adds, Category.AddsColor]}>{content.getValue("header_additives")}</MenuItem>
      <Mobile>
        <MenuDrawerMobile open={open} onClose={() => setOpen(false)} />
      </Mobile>
    </MenuWrapper>
  );
}

export interface IMenu {}

export default Menu;
